import { Controller } from 'react-hook-form'
import { isEmailValid, isPhoneValid } from '../../../../utils/validators'
import WarningMessage from '../../../Common/WarningMessage'
import { useFormContextPatient } from '../_utils'
import PatientFormField from '../PatientFormField'

const Contact = () => {
    const { control } = useFormContextPatient()

    return (
        <>
            <Controller
                control={control}
                name="contactEmail"
                rules={{
                    validate: isEmailValid,
                }}
                render={({ field, fieldState: { error } }) => (
                    <PatientFormField
                        variant="input"
                        label="Email"
                        size="0.5"
                        status={{
                            error,
                            valid: !error && Boolean(field.value),
                            warning: !field.value,
                        }}
                        {...field}
                        dataCyScope="PatientField"
                        placeholder="adresse@email.com"
                        helperText={
                            !field.value ? (
                                <WarningMessage message="Cette information n’a pas encore été complétée" />
                            ) : undefined
                        }
                    />
                )}
            />
            <Controller
                control={control}
                name="contactPhone"
                rules={{
                    validate: (val) => isPhoneValid(val, false),
                }}
                render={({ field, fieldState: { error } }) => (
                    <PatientFormField
                        variant="input"
                        label="Numéro de téléphone portable"
                        size="0.5"
                        status={{
                            error,
                            valid: !error && Boolean(field.value),
                        }}
                        placeholder="00 00 00 00 00"
                        dataCyScope="PatientField"
                        {...field}
                    />
                )}
            />
        </>
    )
}

export default Contact
